export default "__VITE_ASSET__4be03a37__"